import React, { Component } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { getBaseURL } from 'helpers';

const defaultProps = {
    className: '',
    disabled: false,
    height: "250",
    inline: false,
};

const TinyMCEEditor = (rawProps) => {

    const props = {...defaultProps, ...rawProps};

    return (
        <Editor
            className={props.className}
            tinymceScriptSrc={getBaseURL(`/assets/plugins/tinymce/tinymce.bundle.js`)}
            value={props.value}
            onEditorChange={props.onChange}
            onBlur={props.onBlur}
            disabled={props.disabled}
            inline={props.inline}
            init={{
                height: props.height,
                menubar: false,
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                ],
                toolbar: 'undo redo | formatselect | fontsizeselect | ' +
                'bold italic forecolor backcolor | alignleft aligncenter ' +
                'alignright alignjustify | superscript subscript | bullist numlist outdent indent | ' +
                'removeformat | help',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                fontsize_formats: "8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 24pt 30pt 36pt",
                contextmenu: false
            }}
        />
    );
}

export default React.memo(TinyMCEEditor);
